<template>
  <component :is="component" :data="data" v-if="component" @title-update="updateTitle"/>
</template>

<script>
export default {
  name: 'dynamic-story',
  props: {
    data: String,
    story: String,
    episode: String,
    chapter: String
  },
  data () {
    return {
      component: null
    }
  },
  methods: {
    updateTitle (e) {
      this.$store.commit('titleUpdate', e)
    }
  },
  computed: {
    loader () {
      if (!this.story || !this.episode || !this.chapter) {
        return null
      }
      return () => import('./episodes/' + this.episode + '/chapters/' + this.chapter + '/stories/' + this.story + '.vue')
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = () => import('./ChapterTemplate.vue')
      })
  }
}
</script>

<style lang="css" scoped>
</style>
